import React, { useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlus } from "@fortawesome/free-solid-svg-icons";
import { Button } from "react-bootstrap";

export default function ChecklistAddRow({ onAdd }) {
  const [value, setValue] = useState("");

  const submit = (e) => {
    if (e.key) {
      if (e.key !== "Enter")
        return;
      e.preventDefault();
    }
    if (!value.trim()) return;
    onAdd(value);
    setValue("");
  };

  return (
    <div className="custom-checklist-add-row">
      <input
        value={value}
        placeholder="عنوان جدید..."
        onKeyDown={submit}
        onChange={(e) => setValue(e.target.value)}
      />
      <Button onClick={submit} variant="outline-primary">
        <FontAwesomeIcon icon={faPlus} />
      </Button>
    </div>
  );
}